var YT = YT || {};

(function ($) {
  Drupal.behaviors.productHowToVideoV1 = {
    attach: function (context) {
      var self = this;
      var $howToVideo = $('.js-product-how-to-video', context);

      $howToVideo.each(function () {
        var $thisMediaBlock = $(this);
        var $howToVideoBlock = $('.js-how-to-video-container', $thisMediaBlock);
        var $howToVideo = $('.js-how-to-video-media', $thisMediaBlock);
        var $videoPlayer = $('.js-how-to-video-player', $thisMediaBlock);

        $howToVideo.once().on('click touchstart', function () {
          var howToVideoId = $howToVideoBlock.data('youtube-id');

          $howToVideo.addClass('active');
          if ($(this).closest('.js-how-to-video-pc')) {
            $videoPlayer.attr('id', 'player-pc');
            self.initYouTube('player-pc', howToVideoId);
          } else {
            $videoPlayer.attr('id', 'player-mobile');
            self.initYouTube('player-mobile', howToVideoId);
          }
        });
      });
      Unison.on('change', function () {
        var $iframePlayer = $('iframe.js-how-to-video-player', $howToVideo);
        var breakPointName = Unison.fetch.now().name;

        if (breakPointName === 'medium' || breakPointName === 'portrait') {
          $iframePlayer.attr('src', $iframePlayer.attr('src'));
        }
      });
    },
    initYouTube: function (youtubeBlockID, youtubeID) {
      var player = new YT.Player(youtubeBlockID, {
        height: '500',
        width: '900',
        videoId: youtubeID,
        playerVars: { 'autoplay': 1 },
        events: {
          onReady: function (event) {
            if (!Modernizr.touch) {
              event.target.playVideo();
            }
          }
        }
      });
    }

  };
})(jQuery);
